import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => {
  const statusIconColor = [
    theme.palette.error.main,
    theme.palette.grey[500],
    theme.palette.primary.main,
  ];

  return {
    [theme.breakpoints.down("sm")]: {
      cardGridItem: {
        margin: "auto",
      },
      cardGrid: {
        margin: "auto",
      },
      alignItemsEnd: {
        alignItems: "center",
        justifyContent: "center",
      },
    },
    srPagoCard: {
      position: "relative",
      padding: theme.spacing(4),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      minWidth: "calc(220px + 32px * 2)",
    },
    cardGrid: {
      minWidth: "220px",
    },
    cardGridItem: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      padding: "15px",
    },
    cardGridItemAlignLeft: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      padding: "15px",
    },
    alignItemsEnd: {
      alignItems: "flex-end",
    },
    noCards: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginTop: theme.spacing(10),
      fontSize: theme.typography.pxToRem(25),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.grey[500],
    },
    headerSection: {
      display: "flex",
      justifyContent: "space-between",
    },
    textWithIcon: {
      color: theme.palette.grey[500],
      display: "flex",
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
    clickable: {
      cursor: "pointer",
    },
    actionIcon: {
      marginRight: theme.spacing(1),
    },
    statusIcon: {
      color: ({ status }) => statusIconColor[status],
    },
    typographyText: {
      color: theme.palette.grey[500],
      fontSize: theme.typography.pxToRem(16),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
    typographyTextBalance: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
    },
    loader: {
      margin: 0,
      marginRight: "10px",
    },
    cardButton: {
      maxWidth: "180px",
    },
  };
});

export default useStyles;
